// US phone numbers, same behavior as the signup form: shown as (xxx) xxx-xxxx while
// typing, exactly 10 digits required, and only the digits are sent to the backend.

// A leading country code on a pasted number ("+1 555 123 4567") is dropped.
export const phoneDigits = (value) => {
  const digits = String(value || '').replace(/\D/g, '');
  return digits.length > 10 && digits[0] === '1' ? digits.slice(1, 11) : digits.slice(0, 10);
};

export const formatPhoneNumber = (value) => {
  const digits = phoneDigits(value);
  if (digits.length < 4) return digits;
  if (digits.length < 7) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
};

export const isValidPhone = (value) => phoneDigits(value).length === 10;
